<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{contractingInformation}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div (click)="onViewDocumentsTable(newClient)" class="p-3 mb-2 bg-primary text-white rounded">{{newClient}}</div>
    <table class="table table-striped" *ngIf="isNewClientDocumentsTableVisible">
        <thead>
            <tr>
                <th scope="col">{{documentName}}</th>
                <th scope="col">{{documentModel}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let document of newClientDocuments;let i = index">
                <tr>
                    <th scope="row">{{document.nume}}</th>
                    <td><a *ngIf="document.fisier" href="{{comparatorDocumentsUrl + document.fisier}}" target="_blank">{{download}}</a>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <div (click)="onViewDocumentsTable(contractConditionsChange)" class="p-3 mb-2 bg-primary text-white rounded">
        {{contractConditionsChange}}
    </div>
    <table class="table table-striped" *ngIf="isContractConditionsChangeDocumentsTableVisible">
        <thead>
            <tr>
                <th scope="col">{{documentName}}</th>
                <th scope="col">{{documentModel}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let document of sameSupplierDocuments;let i = index">
                <tr>
                    <th scope="row">{{document.nume}}</th>
                    <td><a *ngIf="document.fisier" href="{{comparatorDocumentsUrl + document.fisier}}" target="_blank">{{download}}</a>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <div (click)="onViewDocumentsTable(supplierChange)" class="p-3 mb-2 bg-primary text-white rounded">
        {{supplierChange}}</div>
    <table class="table table-striped" *ngIf="isSupplierChangeDocumentsTableVisible">
        <thead>
            <tr>
                <th scope="col">{{documentName}}</th>
                <th scope="col">{{documentModel}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let document of newSupplierDocuments;let i = index">
                <tr>
                    <th scope="row">{{document.nume}}</th>
                    <td><a *ngIf="document.fisier" href="{{comparatorDocumentsUrl + document.fisier}}" target="_blank">{{download}}</a>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>